// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"180":"e0ec8ac2","4458":"99b924f9","7851":"e0ec8ac2"}[chunkId] + ".chunk.css";
};